var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 32,
    viewBox: "0 0 84 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5468 20.4158H30.1044V21.5725C30.1044 24.744 32.7582 27.3185 36.0274 27.3185V25.0798C34.0275 25.0798 32.4121 23.5127 32.4121 21.5725V20.4158H36.2582V18.1771H32.4121V10.7334H30.1044V18.1771H28.5468V20.4158ZM50.373 27.2065V16.1063H48.0653V18.1211C47.0653 16.8339 45.3346 15.9944 43.6231 15.9944C40.6231 15.9944 38.1808 18.5316 38.1808 21.6471C38.1808 24.7813 40.6231 27.3185 43.6231 27.3185C45.3346 27.3185 47.0653 26.4976 48.0653 25.1917V27.2065H50.373ZM47.6038 21.6471C47.6038 23.5686 46.0077 25.1171 44.0462 25.1171C42.0654 25.1171 40.4693 23.5686 40.4693 21.6471C40.4693 19.7442 42.0654 18.1957 44.0462 18.1957C46.0077 18.1957 47.6038 19.7442 47.6038 21.6471ZM54.9955 27.1879V20.9568C54.9955 19.483 55.9763 18.3263 57.4955 18.3263C58.9955 18.3263 60.0339 19.2591 60.0339 20.4158L60.0532 27.1879H62.3608V20.1733C62.4954 19.1285 63.3993 18.3263 64.5146 18.3263C65.7069 18.3263 66.6685 19.2591 66.6685 20.4158V27.1879H68.9761V20.4158C68.9761 18.0278 66.9761 16.0876 64.5146 16.0876C63.2262 16.0876 62.0531 16.6287 61.2262 17.4682C60.4378 16.6287 59.0339 16.0876 57.4955 16.0876C56.4763 16.0876 55.7455 16.3675 54.9955 16.8339V16.0876H52.6879V27.1879H54.9955ZM70.9042 16.0876V31.9265H73.2119V25.173C74.2119 26.4603 75.9426 27.2998 77.6542 27.2998C80.6541 27.2998 83.0964 24.7626 83.0964 21.6471C83.0964 18.5129 80.6541 15.9757 77.6542 15.9757C75.9426 15.9757 74.2119 16.7966 73.2119 18.1025V16.0876H70.9042ZM73.6734 21.6471C73.6734 19.7255 75.2696 18.1771 77.2311 18.1771C79.2118 18.1771 80.808 19.7255 80.808 21.6471C80.808 23.55 79.2118 25.0984 77.2311 25.0984C75.2696 25.0984 73.6734 23.55 73.6734 21.6471Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3511 11.0173L20.6342 0.026342L18.2477 0.0057373L10.8199 14.6815C10.0833 15.9106 9.6615 17.3393 9.6615 18.8635C9.6615 23.4657 13.5072 27.1964 18.2512 27.1964C22.9952 27.1964 26.8409 23.4657 26.8409 18.8635C26.8409 14.2612 22.9952 10.5304 18.2512 10.5304C17.2336 10.5304 16.2571 10.7021 15.3511 11.0173ZM12.7234 16.4842L12.8744 16.1699C13.8614 14.2673 15.8925 12.962 18.2378 12.962C21.552 12.962 24.2385 15.5683 24.2385 18.7833C24.2385 21.9985 21.552 24.6047 18.2378 24.6047C14.9238 24.6047 12.2372 21.9985 12.2372 18.7833C12.2372 17.9668 12.4105 17.1895 12.7234 16.4842Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2273 0H12.8203C11.0502 0 9.61523 1.39209 9.61523 3.10931V14.9636L17.2273 0Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69209 3.75439L5.73959 5.1679C4.01995 5.99118 3.31387 8.01095 4.16251 9.6792L8.692 18.5833L8.69209 3.75439Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.47217 10.8826L2.7561 11.7429C1.27282 13.525 1.56028 16.1363 3.39805 17.5743L9.41956 22.286L3.47217 10.8826Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 10.4833,
    y1: 0.842105,
    x2: 9.66617,
    y2: 15.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43BCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#662E9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 8.68071,
    y1: 3.75717,
    x2: 8.68071,
    y2: 18.5264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F86624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA3546"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 3.47217,
    y1: 10.8826,
    x2: 9.19778,
    y2: 22.4242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9C80E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F86624"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c517686f602f514c9cd0be98d73ed3fd.svg";
export { ForwardRef as ReactComponent };